<template>
  <div class="select_parts_color">
    <nav class="select_parts_container">
      <li
        v-for="{ id, name, filename } in wall_list"
        :key="id"
        class="parts_color__item"
        :class="{disabled: selectedIds.includes(id)}"
      >
        <button class="parts_item__btn" :disabled="selectedIds.includes(id)" @click="setAttrib(id, $event)">
          <div class="color_chip__container">
            <img
              class="color_chip"
              :src="`item_image/wall/repeat/${filename}`"
              :alt="name"
              :title="name"
            />
          </div>
          <div class="color_name">{{ name }}</div>
        </button>
      </li>
    </nav>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import Util from '../../assets/js/util'
import CONST from '../../assets/js/const'
const {EDIT_CIRCLE_RADIUS, EDIT_RECT_SIZE} = CONST;

export default {
  name: "SelectPartsColor",
  data () {
    return {
      curtain2: [[30,10.5], [76,10.5], [30,56.5], [76,56.5]], //正方形/10
      wall_list: [
        {
          "id": "01_beige",
          "name": "ベージュ",
          "filename": "01_beige.jpg"
        },
        {
          "id": "02_bluegray",
          "name": "ブルーグレー",
          "filename": "02_bluegray.jpg"
        },
        {
          "id": "03_gray",
          "name": "グレー",
          "filename": "03_gray.jpg"
        },
        {
          "id": "04_greengray",
          "name": "グリーングレー",
          "filename": "04_greengray.jpg"
        },
        {
          "id": "05_darkgray",
          "name": "ダークグレー",
          "filename": "05_darkgray.jpg"
        },
        {
          "id": "06_navy",
          "name": "ネイビー",
          "filename": "06_navy.jpg"
        }
      ]
    }
  },
  computed: {
    ...mapState('simulator', ["editing_id"]),
    ...mapGetters("simulator", ["editing_item", "wall_in_imageList"]),
    // ...mapGetters("simulator", ["parts_list", "editing_parts"])
    selectedIds () {
      return this.wall_in_imageList.map(({item_data}) => item_data.name)
    }
  },
  methods: {
    ...mapMutations(['setRectWidth', 'setRectHeight']),
    ...mapMutations('simulator', ["createTempItem", "deleteTempItem", "updateTempItem", "setIsContinuingLoading"]),
    ...mapActions('simulator', ['justUpdateItemInfo', "updateItemInfo", "commitTempItem",]),
    async setAttrib (id, { target, currentTarget }) {
      let clearId = null
      currentTarget.parentElement.classList.add('disabled')
      new Promise ((resolve) => {
        target.parentElement.addEventListener('transitionend', () => {
          resolve()
        }, { once: true })
        clearId = setTimeout(() => resolve(), 100)
      }).then(async() => {
        clearId && clearTimeout(clearId)

        this.setWallpaper(id);

        this.$emit('closeModal')
      })
    },
    async setWallpaper(id) {
      const item_type = CONST.ITEM_TYPE_WALL;
      const curtain_type = null;

      this.createTempItem();
      this.updateTempItem({
        points: {
          top_left:     {x: EDIT_CIRCLE_RADIUS, y: EDIT_CIRCLE_RADIUS},
          top_right:    {x: EDIT_RECT_SIZE,     y: EDIT_CIRCLE_RADIUS},
          bottom_left:  {x: EDIT_CIRCLE_RADIUS, y: EDIT_RECT_SIZE},
          bottom_right: {x: EDIT_RECT_SIZE,     y: EDIT_RECT_SIZE},
        },
        rect_width: 2000,
        rect_height: 2000,
        item_type,
        curtain_type,
        order: 10000,
      });

      await this.setPosition(this.curtain2);
      await this.commitTempItem();
      await this.deleteTempItem();

      this.setRectWidth(this.editing_item.rect_width);
      this.setRectHeight(this.editing_item.rect_height);

      this.updateItemInfo({
        item_data: {
          name: id,
          width: 200,
          height: 200,
        },
        progress: -1,
      });
    },
    async setPosition(points) {
      const calculated_points = Util.calculatePoint(points);
      this.updateTempItem({points: calculated_points});
    },
  }
};
</script>

<style lang="scss" scoped>
.select_parts_color {
  height: 100%;
  .select_parts_container {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    margin: 0 auto;
    width: calc(332 / 349 * 100%);
    min-height: 100%;
    .parts_color__item {
      position: relative;
      list-style: none;
      flex: 0 0 auto;
      flex-basis: calc(146 / 332 * 100%);
      margin: calc(10 / 332 * 100%);
      &.disabled {
        .parts_item__btn {
          top: -4px;
          left: -4px;
          width: calc(100% + 8px);
          height: calc(100% + 8px);
          padding: 0 calc(8 / 146 * 100%);
          border: 4px solid #000;
        }
      }
      &::before {
        display: block;
        content: '';
        padding-top: calc(30 / 142 * 100%);
      }
      .parts_item__btn {
        position: absolute;
        display: flex;
        align-items: center;
        top: -2px;
        left: -2px;
        width: calc(100% + 4px);
        height: calc(100% + 4px);
        padding: 0 calc(4 / 146 * 100%);
        appearance: none;
        border: 1px solid #000;
        border-radius: 6px;
        background-color: #fff;
        &:disabled {
          color: currentColor;
        }
        .color_chip__container {
          position: relative;
          flex: 0 0 auto;
          flex-basis: calc(45 / 146 * 100%);
          border: 1px solid #000;
          border-radius: 6px;
          overflow: hidden;
          &::before {
            display: block;
            content: '';
            padding-top: calc(18 / 45 * 100%);
          }
          .color_chip {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
        }
        .color_name {
          flex: 1 0 auto;
          flex-basis: 50%;
          margin-left: calc(4 / 146 * 100%);
          word-break: keep-all;
          line-break: strict;
          word-wrap: break-word;
          overflow-wrap: break-word;
          font-size: clamp(10px, 1.2vw, 18px);
        }
      }
    }
  }
}
</style>
